import { apiUrl } from '../../config.js';

export const partnershipData = (data) => ({
	type: 'GET_PARTNERSHIP_DATA',
	axios: true,
	options: {
		url: `${apiUrl}/partnership/get-partnership-data?aj=1&url=${data}`,
		method: 'get'
	}
});


// WEBPACK FOOTER //
// ../q-cars/src/redux/actions/partnerships.js